import { cva } from "class-variance-authority"
import * as React from "react"
import { cn } from "../../lib/utils"

export interface PillProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode
  className?: string
  variant?: "primary" | "danger" | "secondary"
  size?: "sm" | "md"
}

const pillVariants = cva(
  "px-1 inline-flex items-center rounded-4 text-root-size-body-lg font-500 text-root-text-color-base",
  {
    variants: {
      variant: {
        primary:
          "px-2 py-1 bg-feedback-tertiary-background group-hover:bg-[#EFF1F2] group-data-[state=selected]:bg-[#F5EADE] group-hover:group-data-[state=selected]:bg-[#F5E0CB]",
        danger: "bg-feedback-danger-background",
        secondary: "bg-feedback-secondary-background",
      },
      size: {
        sm: "text-[12px]/[8px] p-1", // TODO: Remove this once we have tokens
        md: "text-root-size-body-md",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
    },
  }
)

/**
 * TODO: Replace with semantic tokens when available
 */
const Pill = React.forwardRef<HTMLSpanElement, PillProps>(
  ({ children, className, variant = "primary", size = "md", ...props }, ref) => {
    return (
      <span ref={ref} className={cn(pillVariants({ variant, size }), className)} {...props}>
        {children}
      </span>
    )
  }
)

Pill.displayName = "Pill"

export { Pill }
